import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SIZES } from './constants';

function ColorCircle({ color = '', secondColor = '', opacity = 1, size = SIZES.medium }) {
  const isNotProvided = Boolean(!color && !secondColor);
  const classes = classNames('ws-ui-color-circle', `ws-ui-color-circle--${size}`, {
    'ws-ui-color-circle--not-provided': isNotProvided,
  });

  return (
    <div
      className={classes}
      style={{
        '--color': color || secondColor,
        '--second-color': secondColor || color,
        '--opacity': opacity,
      }}
    />
  );
}

ColorCircle.propTypes = {
  color: PropTypes.string,
  secondColor: PropTypes.string,
  opacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(Object.values(SIZES)),
};

export default ColorCircle;
